/* unplugin-vue-components disabled */import script from "./CharacterSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CharacterSelect.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__